export const messageSize_MB = "gPtmKb";
export const messageSize_KB = "CRTlKb";
export default {messageSize_MB,messageSize_KB};